import { render, staticRenderFns } from "./extensions.vue?vue&type=template&id=592dbac8&scoped=true"
import script from "./extensions.vue?vue&type=script&lang=js"
export * from "./extensions.vue?vue&type=script&lang=js"
import style0 from "./extensions.vue?vue&type=style&index=0&id=592dbac8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592dbac8",
  null
  
)

export default component.exports